import { PageInfoBar } from "@components/common/page-info-bar";
import { WorkspaceRoleDropdown } from "@components/role/workspace-role-dropdown";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** Member data to display and edit the workspace role for */
  member: FaroCoreApiTypes.CompanyMemberDetails;
}

/**
 * Component that shows the info bar of a single member.
 * Shows the workspace role as an editable dropdown (if the user has permission).
 */
export function MemberProfileInfoBar({ member }: Props): JSX.Element {
  return (
    <PageInfoBar
      items={[
        {
          content: <WorkspaceRoleDropdown member={member} />,
        },
      ]}
    />
  );
}
